export default {
  meta: {
    title: '筹建管理看板',
  },
};
